  <div class="pager">
      <!-- Prev -->
      <ed-button
        [colorSchema]="ButtonColors.Secondary"
        [disabled]="currentPage <= 1"
        (click)="goPrev()"
        aria-label="Previous page"
      >&lt;</ed-button>

      <!-- Pages -->
      @for (p of pages(); track p; let i = $index) {
        @if (p === '...') {
          <ed-button
            [colorSchema]="ButtonColors.Secondary"
            [disabled]="true"
            class="ellipsis"
            aria-hidden="true"
          >…</ed-button>
        } @else {
          <ed-button
            [colorSchema]="currentPage === p ? ButtonColors.Primary : ButtonColors.Secondary"
            [disabled]="currentPage === p"
            (click)="goTo(p)"
          >{{ p }}</ed-button>
        }
      }

      <!-- Next -->
      <ed-button
        [colorSchema]="ButtonColors.Secondary"
        [disabled]="currentPage >= totalPages"
        (click)="goNext()"
        aria-label="Next page"
      >&gt;</ed-button>
    </div>